import { render, staticRenderFns } from "./LegendColor.vue?vue&type=template&id=0700c960&scoped=true&"
import script from "./LegendColor.vue?vue&type=script&lang=js&"
export * from "./LegendColor.vue?vue&type=script&lang=js&"
import style0 from "./LegendColor.vue?vue&type=style&index=0&id=0700c960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0700c960",
  null
  
)

export default component.exports